import { render } from "./BtnCallQueueArrival.vue?vue&type=template&id=a68fe726&scoped=true"
import script from "./BtnCallQueueArrival.vue?vue&type=script&lang=js"
export * from "./BtnCallQueueArrival.vue?vue&type=script&lang=js"

import "./BtnCallQueueArrival.vue?vue&type=style&index=0&id=a68fe726&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68fe726"]])

export default __exports__